import { APP_ID } from '../constants';
import { ApiResponse } from '../types/api';
import { Facility } from '../types/model';
import { lifeApi } from './base';

const postFacilities = lifeApi.injectEndpoints({
  endpoints: (builder) => ({
    postFacilities: builder.query<ApiResponse<Facility[]>, void>({
      query: () => ({
        url: 'facilities',
        method: 'POST',
        body: {
          appId: APP_ID,
          mode: 'full',
          lastSyncDate: '2024-04-25',
          resource: 'facility',
        },
      }),
    }),
  }),
});

export const { usePostFacilitiesQuery } = postFacilities;
